import React from 'react';
import { useTranslation } from 'react-i18next';
import { FullViewProps } from '../types';
import s from './Unknown.scss';

export interface Props extends FullViewProps {
  type?: string; // just for devtools debugging
}

export const Unknown: React.FC<Props> = ({ width, height }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']} style={{ width, height }}>
      {t('deviationview.unknown')}
    </div>
  );
};
Unknown.displayName = 'Unknown';

export default Unknown;
